import { graphql } from "@/shared/gql";
import { useCompanyId } from "@/entities/company/hooks/use-company-id";
import { useSuspenseQuery } from "@apollo/client";
import { EntityNotFoundError } from "@/shared/lib/errors/404-not-found-error";
import type { ContentType } from "@/shared/gql/graphql";
import { getPreloadQuery } from "@/shared/gql/apollo-client";

export const FetchCompanyWorkflows = graphql(`
  query FetchCompanyWorkflows($companyId: ID!) {
    currentUser(company: $companyId) {
      id
      company {
        id
        workflows {
          id
          ...AllWorkflowsProps
        }
      }
    }
  }
`);

type UseFetchCompanyWorkflowsQueryParams = {
  contentType: ContentType;
};

export const useFetchCompanyWorkflowsQuery = ({
  contentType,
}: UseFetchCompanyWorkflowsQueryParams) => {
  const companyId = useCompanyId();
  const result = useSuspenseQuery(FetchCompanyWorkflows, {
    variables: { companyId },
  });

  if (result.error) {
    throw result.error;
  }

  if (!result.data) {
    throw new EntityNotFoundError("Data");
  }

  if (!result.data.currentUser.company) {
    throw new EntityNotFoundError("Company");
  }

  const workflows = result.data.currentUser.company.workflows;

  return workflows.filter((workflow) => workflow.contentType === contentType);
};

// Warms the Apollo cache during route transition so the side panel's suspense
// read hits a pre-warmed cache instead of firing only after the detail query
// resolves.
export const preloadCompanyWorkflowsQuery = (companyId: string) => {
  getPreloadQuery()(FetchCompanyWorkflows, {
    variables: { companyId },
  });
};
